<template>
  <div>
    <div class="subject-preference">
      <div class="preference-title-row">
        <!-- TITLE -->
        <div class="preference-title color_ash">Admin Users</div>
        <!-- PLUS ICON -->
        <div class="avatar pointer" @click="toggleUserModal" title="Add User">
          <span
            class="flex-center icon-plus font-17 color_text font-weight-600"
          ></span>
        </div>
      </div>

      <div class="info-text color_ash">
        Add more school administrators, manage their roles and activities.
      </div>

      <!-- USER CARD COMPONENTS -->
      <div
        class="loader d-flex justify-content-center align-items-center my-4"
        v-if="user_list.length < 1"
      >
        <div class="avatar">
          <span
            class="icon-dotted-spinner flex-center font-24 border_grey-dark animate mr-3"
          ></span>
        </div>
        <div class="text color_grey_dark font-14-5">Loading Users ....</div>
      </div>

      <UserCard
        :user_id="user.user_id"
        :fullname="user.name"
        :email="user.email"
        :image="user.image"
        :role="user.role"
        :level="user.level"
        :status="user.status"
        @remount="remountComponent"
        @showAlertCard="popUpAlert($event)"
        @edit-role="toggleUserRoleModal($event)"
        v-for="(user, index) in user_list"
        :key="index"
        v-else
      ></UserCard>
      <!-- USER CARD COMPONENTS -->

      <div class="pending-users-section">
        <div
          class="pending-users-title color_ash text-uppercase"
          v-if="pending_user_list.length > 0"
        >
          Pending Users
        </div>
        <UserCard
          :user_id="user.user_id"
          :fullname="user.name"
          :email="user.email"
          :role="user.role"
          :status="user.status"
          @removeUser="extractPendingUser($event)"
          @showAlertCard="popUpAlert($event)"
          v-for="(user, index) in pending_user_list"
          :key="index"
        ></UserCard>
      </div>

      <!-- MODAL COMPONENTS -->
      <AddUserModal
        v-if="user_modal"
        @closeTriggered="toggleUserModal"
        @updatePendingList="appendToPendingUsers($event)"
        @showAlertCard="popUpAlert($event)"
      ></AddUserModal>

      <EditUserRoleModal
        v-if="user_role"
        :user_obj="user_obj"
        @closeTriggered="toggleUserRoleModal"
        @showAlertCard="popUpAlert($event)"
      ></EditUserRoleModal>

      <ResponseDialog
        v-if="response_dialog"
        :alert_msg="alert_card_msg"
        :alert_type="alert_card_type"
        @closeAlert="toggleResponseDialog"
      ></ResponseDialog>
      <!-- MODAL COMPONENTS-->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "UserPreference",

  components: {
    UserCard: () =>
      import(
        /* webpackChunkName: "UserCard" */ "@/components/globalComps/SettingsComps/PreferenceComps/UserCard"
      ),
    AddUserModal: () =>
      import(
        /* webpackChunkName: "AddUserModal" */ "@/components/modalComps/settingsModals/AddUserModal"
      ),
    EditUserRoleModal: () =>
      import(
        /* webpackChunkName: "EditUserRoleModal" */ "@/components/modalComps/settingsModals/EditUserRoleModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  data() {
    return {
      user_modal: false,
      user_role: false,

      user_list: [],
      pending_user_list: [],

      user_obj: null,
      update_count: 0,

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  created() {
    this.fetchUserList();
    this.fetchPendingUserList();
  },

  mounted() {
    this.checkIfModalIsSet();
  },

  methods: {
    ...mapActions(["getUserList", "getPendingUserList"]),

    checkIfModalIsSet() {
      let pop_modal = this.$route.query.modal;
      pop_modal ? this.toggleUserModal() : null;
    },

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    popUpAlert($event) {
      this.alert_card_msg = $event.msg;
      this.alert_card_type = $event.type;
      this.toggleResponseDialog();
    },

    remountComponent() {
      this.user_list = [];
      this.fetchUserList();
    },

    appendToPendingUsers(user) {
      this.pending_user_list.push(user);
    },

    extractPendingUser(user_id) {
      this.pending_user_list = this.pending_user_list.filter(
        (user) => user.user_id !== user_id
      );
    },

    toggleUserModal() {
      this.user_modal = !this.user_modal;
    },

    toggleUserRoleModal($event) {
      this.user_role = !this.user_role;
      this.user_obj = $event;

      this.remountComponent();
    },

    fetchUserList() {
      this.getUserList()
        .then((response) => {
          if (response.code === 200) {
            response.data.map((user) => {
              let user_data = {};
              user_data.user_id = Number(user.user_id);
              user_data.name = `${user.firstname} ${user.lastname}`;
              user_data.email = user.email;
              user_data.image = user.image;
              user_data.role = user.title;
              user_data.level = user.level;
              user_data.status = Number(user.status);

              this.user_list.push(user_data);
            });
          }
        })
        .catch((err) => console.log(err));
    },

    fetchPendingUserList() {
      this.getPendingUserList()
        .then((response) => {
          console.log(response);
          this.pending_user_list = response.data.map((user) => {
            return {
              user_id: Number(user.id),
              name: user.receiver_email,
              email: user.receiver_email,
              role: user.extra_data,
              status: Number(user.status),
            };
          });
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.preference-title {
  @include breakpoint_max(sm) {
    font-size: 12.5px !important;
  }
}

.info-text {
  font-size: 14px;
  line-height: 165%;
  margin-top: -10px;
  margin-bottom: 30px;

  @include breakpoint_max(sm) {
    font-size: 12.5px;
    margin-bottom: 20px;
  }
}

.pending-users-section {
  .pending-users-title {
    font-weight: bold;
    font-size: 14.5px;
    line-height: 22px;
    margin-top: 50px;
    margin-bottom: 30px;

    @include breakpoint_max(sm) {
      font-size: 12.5px;
      margin-bottom: 20px;
    }
  }
}
</style>

